<template>
  <div id="modalBanner" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="editando">Editar banner</span>
            <span v-else>Crear banner</span>
          </h5>
          <div class="acciones-modal">
            <button
              :disabled="!PuedeGuardar"
              type="button"
              class="btn btn-success"
              @click="clickGuardar()"
            >
              <font-awesome-icon v-if="!guardando" :icon="Icons.ACEPTAR" />
              <div
                v-else
                id="indicador-guardado"
                class="spinner-border"
                role="status"
              ></div>
            </button>
            <button
              type="button"
              class="btn-close"
              @click="clickCerrar()"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="item" class="row justify-content-center">
            <!-- Logo -->
            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <CargadorImagen
                ref="cargadorImagen"
                v-on:agregado="logoAgregado"
                v-on:eliminado="logoEliminado"
              />
            </div>
            <!-- Pantalla -->
            <div class="col-12 col-md-6 col-lg-4 mb-3">
              <label>Pantalla</label>
              <select v-model="item.pantalla" class="custom-select">
                <option v-bind:value="Pantalla.ambas" selected>Ambas</option>
                <option v-bind:value="Pantalla.chica">Chica</option>
                <option v-bind:value="Pantalla.grande">Grande</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const bootstrap = require("bootstrap");

import axios from "axios";
import { environment } from "../../../environments/environment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { Api } from "../../../api";
import CargadorImagen from "../../util/CargadorImagen";
import { Icons as IconConstants } from "../../../constants";
import { TipoPantalla } from "../../../data/enums";
import { Util } from "../../../util";

// Usado para realizar copias profundas y para que las computed properties funcionen correctamente
// a la hora de limpiar los datos solo hay que hacer copiaProfunda de este objeto
const ITEM_LIMPIO = {
  // Nombre de imagen
  name: "",
  pantalla: TipoPantalla.ambas,
};

export default {
  components: {
    FontAwesomeIcon,

    CargadorImagen,
  },
  data() {
    return {
      archivoImagen: null,
      editando: false,
      guardando: false,
      item: null,
      modal: null,
      token: "",
    };
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    Pantalla() {
      return TipoPantalla;
    },
    PuedeGuardar() {
      return this.archivoImagen != null;
    },
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    /**
     * @param {object} item Item editado, si no se pasa, se abre en modo creación
     */
    EventoAbrir(item = null) {
      if (item) {
        // Trabajar con una copia profunda para que no se apliquen los cambios directamente
        this.item = Util.copiaProfunda(item);
        this.editando = true;
      } else {
        this.item = Util.copiaProfunda(ITEM_LIMPIO);
        this.editando = false;
      }
      this.modal.show();
    },
    EventoCerrar() {
      this.cerrar();
    },
    // ---------------- Métodos internos -------------------
    cerrar() {
      this.$refs.cargadorImagen.EventoLimpiar();

      this.$emit("cerrar");
      this.modal.hide();
    },
    clickCerrar() {
      this.cerrar();
    },
    clickGuardar() {
      this.guardando = true;

      if (this.editando) {
        this.cerrar();
        this.guardando = false;
      }
      // Se está creando
      else {
        /*********  PRIMERO ME ASEGURO DE SUBIR LA IMAGEN**************/
        let formData = new FormData();
        formData.append("image", this.archivoImagen);

        axios
          .post(environment.API_URL + "uploads/banners", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            axios
              .post(environment.API_URL + "banner", this.item, {
                headers: { Authorization: "Token " + this.token },
              })
              .then(() => {
                this.$refs.cargadorImagen.EventoLimpiar();

                this.$emit("creado", this.item);
                this.cerrar();
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                this.guardando = false;
              });
          })
          .catch((error) => {
            console.error(error);
            this.guardando = false;
          });
      }
    },
    logoAgregado(archivo) {
      this.archivoImagen = archivo;
      this.item.name = this.archivoImagen.name;
    },
    logoEliminado() {
      this.item.name = "";
      this.archivoImagen = null;
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");

    Api.Comercio.getTodos(this.token).then((response) => {
      this.comercios = response.data;
    });

    Api.Categoria.getTodas().then((response) => {
      this.categorias = response.data;
    });

    const opcionesModal = {};
    this.modal = new bootstrap.Modal(
      document.getElementById("modalBanner"),
      opcionesModal
    );
  },
};
</script>
<style scoped>
#indicador-guardado {
  width: 16px;
  height: 16px;
}
label {
  width: 100%;
  text-align: left;
  font-size: 14px;
  margin-left: 5px;
  margin-bottom: 1px;
}
</style>